/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SysqueDropdownOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-dropdown-options-line';
import { SysqueNumberBoxOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-number-box-options-line';
import { SysqueRadioButtonOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-radio-button-options-line';
import { SysqueCheckBoxOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-check-box-options-line';
import { SysqueLocationOptionsLineModule } from '../../../../../../../../../../../shared/ui/src/lib/components/sysque-location-options-line';
import { ConduitSettingsElevationTagComponent } from './conduit-settings-elevation-tag.component';

@NgModule({
  declarations: [ConduitSettingsElevationTagComponent],
  imports: [
    CommonModule,
    FormsModule,
    SysqueDropdownOptionsLineModule,
    SysqueNumberBoxOptionsLineModule,
    SysqueRadioButtonOptionsLineModule,
    SysqueCheckBoxOptionsLineModule,
    SysqueLocationOptionsLineModule
  ],
  exports: [ConduitSettingsElevationTagComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConduitSettingsElevationTagModule {}
